<template>
  <section class="vbox">    
    <section class="scrollable wrapper">
      <el-tabs type="border-card">
        <el-tab-pane label="关键字回复">
          <el-button type="primary" class="el-icon-circle-plus-outline" >新增</el-button>
          <el-table :data="keyReplys" style="width: 100%">
            <el-table-column  prop="Key" label="关键字"> </el-table-column>
            <el-table-column  prop="ReplyType"  label="回复类型" > 
              <template slot-scope="scope">                    
                <p v-if="scope.row.ReplyType=='0'">文本</p>
                <p v-if="scope.row.ReplyType=='1'">素材</p>         
              </template>
            </el-table-column>
            <el-table-column  prop="ReplyContent"  label="回复内容"> </el-table-column>            
            <el-table-column  fixed="right" label="操作" width="120">
              <template slot-scope="scope">
                <el-button @click.native.prevent="editCategory(scope.$index, categorys)" type="text" size="small">
                  编辑
                </el-button>
                <el-button @click.native.prevent="deleteRow(scope.$index, categorys)" type="text" size="small">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="收到消息回复">
          <el-form ref="form" label-width="80px">
            <el-form-item label="">
              <el-col :span="11">
                <editor @showEditor="updateweChatOfficialAccountReply" :content="weChat_OfficialAccount_Reply"></editor>
              </el-col>
            </el-form-item>
            <el-form-item label="">
              <el-col :span="11">
                <el-button type="primary" @click="SaveWeChatOfficialAccountReply">确 定</el-button>
              </el-col>
            </el-form-item>
          </el-form>          
        </el-tab-pane>
        <el-tab-pane label="被关注回复"> 
          <el-form ref="form" label-width="80px">
            <el-form-item label="">
              <el-col :span="11">
                <editor @showEditor="updateweChatOfficialAccountFocusOnReply" :content="weChat_OfficialAccount_FocusOnReply"></editor>  
              </el-col>
            </el-form-item>
            <el-form-item label="">
              <el-col :span="11">
                <el-button type="primary" @click="SaveWeChatOfficialAccountFocusOnReply">确 定</el-button>
              </el-col>
            </el-form-item>
          </el-form>   
        </el-tab-pane>
      </el-tabs>
    </section>  
  </section>
</template>
<script  type='text/ecmascript-6'>
  import { Message } from 'element-ui'
  import editor from '@/components/wang-editor'
  import qs from 'qs' 
  export default {
    props:{
    },
    data (){
      return {
        keyReplys:[],
        pageIndex:1,
        pagesize:10,
        totalCount:10,
        weChat_OfficialAccount_Reply:'',
        weChat_OfficialAccount_FocusOnReply:''
      }
    },
    computed:{
    },
    mounted(){   
      this.ReplaysGet()  
    },
    methods:{     
      ReplaysGet:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/Wechat/WechatReplyGet',         
          params:{
            pageIndex : that.pageIndex,
            pagesize : that.pagesize
          }
        }).then(function (resp) {
          that.keyReplys = resp.data.keyReplys
          that.weChat_OfficialAccount_Reply = resp.data.weChat_OfficialAccount_Reply
          that.weChat_OfficialAccount_FocusOnReply = resp.data.weChat_OfficialAccount_FocusOnReply
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      updateweChatOfficialAccountReply:function(data){
        this.weChat_OfficialAccount_Reply = data 
      },
      updateweChatOfficialAccountFocusOnReply:function(data){
        this.weChat_OfficialAccount_FocusOnReply = data
      },
      SaveWeChatOfficialAccountReply:function(){
        var data={
          weChat_OfficialAccount_Reply : this.weChat_OfficialAccount_Reply
        }
        this.SaveParames(data)
      },
      SaveWeChatOfficialAccountFocusOnReply:function(){
        var data={
          weChat_OfficialAccount_FocusOnReply : this.weChat_OfficialAccount_FocusOnReply
        }
        this.SaveParames(data)
      },
      SaveParames:function(dataObj){
        var that = this        
        dataObj = qs.stringify(dataObj)
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/System/SaveParameter', 
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },        
          data:dataObj
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      }
    },
    components:{
      editor
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
  .content-header
    padding 24px
    border 1px solid #C0C4CC
    margin-bottom 24px
</style>